import React from 'react';
import { useMapEvents } from 'react-leaflet';

const MapClickHandler = ({ onPositionChange }) => {
    useMapEvents({
        click: (e) => {
            onPositionChange([e.latlng.lat, e.latlng.lng]);
        },
    });
    return null;
};

export default MapClickHandler;

